export default {
  en: 'Height',
  ar: 'طول'
};
